import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
// @ts-ignore
import LZString from 'lz-string';
import addHiddenInput from 'docs/src/modules/utils/addHiddenInput';
import SandboxDependencies from 'docs/src/modules/sandbox/Dependencies';
import * as CRA from 'docs/src/modules/sandbox/CreateReactApp';
import getFileExtension from 'docs/src/modules/sandbox/FileExtension';
import flattenRelativeImports from 'docs/src/modules/sandbox/FlattenRelativeImports';
var CSB_DEV_DEPENDENCIES = {
  'react-scripts': 'latest'
};
function compress(object) {
  return LZString.compressToBase64(JSON.stringify(object)).replace(/\+/g, '-') // Convert '+' to '-'
  .replace(/\//g, '_') // Convert '/' to '_'
  .replace(/=+$/, ''); // Remove ending '='
}
function _openSandbox(_ref) {
  var files = _ref.files,
    codeVariant = _ref.codeVariant,
    initialFile = _ref.initialFile;
  var extension = codeVariant === 'TS' ? '.tsx' : '.js';
  var parameters = compress({
    files: files
  });

  // ref: https://codesandbox.io/docs/api/#define-api
  var form = document.createElement('form');
  form.method = 'POST';
  form.target = '_blank';
  form.action = 'https://codesandbox.io/api/v1/sandboxes/define';
  addHiddenInput(form, 'parameters', parameters);
  addHiddenInput(form, 'embed', '1');
  addHiddenInput(form, 'query', "module=".concat(initialFile).concat(initialFile.match(/(\.tsx|\.ts|\.js)$/) ? '' : extension, "&fontsize=12"));
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
function createReactApp(demoData) {
  var ext = getFileExtension(demoData.codeVariant);
  var title = demoData.title,
    description = demoData.githubLocation;
  var files = _extends(_defineProperty(_defineProperty({
    'public/index.html': {
      content: CRA.getHtml(demoData)
    }
  }, "src/index.".concat(ext), {
    content: CRA.getRootIndex(demoData)
  }), "src/Demo.".concat(ext), {
    content: flattenRelativeImports(demoData.raw)
  }), demoData.relativeModules &&
  // Transform the relative modules array into an object
  demoData.relativeModules.reduce(function (acc, curr) {
    return _extends({}, acc, _defineProperty({}, "src/".concat(curr.module.replace(/^.*[\\/]/g, '')), {
      content: flattenRelativeImports(curr.raw)
    }));
  }, {}), demoData.codeVariant === 'TS' && {
    'tsconfig.json': {
      content: CRA.getTsconfig()
    }
  });
  var _SandboxDependencies = SandboxDependencies(demoData, {
      commitRef: process.env.PULL_REQUEST_ID ? process.env.COMMIT_REF : undefined,
      devDeps: CSB_DEV_DEPENDENCIES
    }),
    dependencies = _SandboxDependencies.dependencies,
    devDependencies = _SandboxDependencies.devDependencies;
  files['package.json'] = {
    content: {
      "private": true,
      description: description,
      dependencies: dependencies,
      devDependencies: devDependencies,
      scripts: {
        start: 'react-scripts start',
        build: 'react-scripts build',
        test: 'react-scripts test',
        eject: 'react-scripts eject'
      }
    }
  };
  return {
    title: title,
    description: description,
    files: files,
    dependencies: dependencies,
    devDependencies: devDependencies,
    /**
     * @param {string} initialFile
     * @description should start with `/`, for example `/Demo.tsx`. If the extension is not provided,
     * it will be appended based on the code variant.
     */
    openSandbox: function openSandbox() {
      var initialFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/src/Demo.".concat(ext);
      return _openSandbox({
        files: files,
        codeVariant: demoData.codeVariant,
        initialFile: initialFile
      });
    }
  };
}
function createJoyTemplate(templateData) {
  var ext = getFileExtension(templateData.codeVariant);
  var title = templateData.title,
    description = templateData.githubLocation;

  // document.querySelector returns 'Element | null' but createRoot expects 'Element | DocumentFragment'.
  var type = templateData.codeVariant === 'TS' ? '!' : '';
  var files = _extends(_defineProperty({
    'public/index.html': {
      content: CRA.getHtml({
        title: templateData.title,
        language: 'en'
      })
    }
  }, "index.".concat(ext), {
    content: "import * as React from 'react';\nimport * as ReactDOM from 'react-dom/client';\nimport { StyledEngineProvider } from '@mui/joy/styles';\nimport App from './App';\n\nReactDOM.createRoot(document.querySelector(\"#root\")".concat(type, ").render(\n  <React.StrictMode>\n    <StyledEngineProvider injectFirst>\n      <App />\n    </StyledEngineProvider>\n  </React.StrictMode>\n);")
  }), Object.entries(templateData.files).reduce(function (prev, curr) {
    return _extends({}, prev, _defineProperty({}, curr[0], {
      content: curr[1]
    }));
  }, {}), templateData.codeVariant === 'TS' && {
    'tsconfig.json': {
      content: CRA.getTsconfig()
    }
  });
  var _SandboxDependencies2 = SandboxDependencies({
      codeVariant: templateData.codeVariant,
      raw: Object.entries(templateData.files).reduce(function (prev, curr) {
        return "".concat(prev, "\n").concat(curr);
      }, ''),
      productId: 'joy-ui'
    }, {
      commitRef: process.env.PULL_REQUEST_ID ? process.env.COMMIT_REF : undefined,
      devDeps: CSB_DEV_DEPENDENCIES
    }),
    dependencies = _SandboxDependencies2.dependencies,
    devDependencies = _SandboxDependencies2.devDependencies;
  files['package.json'] = {
    content: {
      "private": true,
      description: description,
      dependencies: dependencies,
      devDependencies: devDependencies,
      scripts: {
        start: 'react-scripts start',
        build: 'react-scripts build',
        test: 'react-scripts test',
        eject: 'react-scripts eject'
      }
    }
  };
  return {
    title: title,
    files: files,
    dependencies: dependencies,
    devDependencies: devDependencies,
    openSandbox: function openSandbox() {
      var initialFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/App';
      return _openSandbox({
        files: files,
        codeVariant: templateData.codeVariant,
        initialFile: initialFile
      });
    }
  };
}
function createMaterialTemplate(templateData) {
  var ext = getFileExtension(templateData.codeVariant);
  var title = templateData.title,
    description = templateData.githubLocation;

  // document.querySelector returns 'Element | null' but createRoot expects 'Element | DocumentFragment'.
  var type = templateData.codeVariant === 'TS' ? '!' : '';
  var files = _extends(_defineProperty({
    'public/index.html': {
      content: CRA.getHtml({
        title: templateData.title,
        language: 'en'
      })
    }
  }, "index.".concat(ext), {
    content: "import * as React from 'react';\nimport * as ReactDOM from 'react-dom/client';\nimport { StyledEngineProvider } from '@mui/material/styles';\nimport App from './App';\n\nReactDOM.createRoot(document.querySelector(\"#root\")".concat(type, ").render(\n  <React.StrictMode>\n    <StyledEngineProvider injectFirst>\n      <App />\n    </StyledEngineProvider>\n  </React.StrictMode>\n);")
  }), Object.entries(templateData.files).reduce(function (prev, curr) {
    return _extends({}, prev, _defineProperty({}, curr[0], {
      content: curr[1]
    }));
  }, {}), templateData.codeVariant === 'TS' && {
    'tsconfig.json': {
      content: CRA.getTsconfig()
    }
  });
  var _SandboxDependencies3 = SandboxDependencies({
      codeVariant: templateData.codeVariant,
      raw: Object.entries(templateData.files).reduce(function (prev, curr) {
        return "".concat(prev, "\n").concat(curr);
      }, ''),
      productId: 'material-ui'
    }, {
      commitRef: process.env.PULL_REQUEST_ID ? process.env.COMMIT_REF : undefined,
      devDeps: CSB_DEV_DEPENDENCIES
    }),
    dependencies = _SandboxDependencies3.dependencies,
    devDependencies = _SandboxDependencies3.devDependencies;
  files['package.json'] = {
    content: {
      "private": true,
      description: description,
      dependencies: dependencies,
      devDependencies: devDependencies,
      scripts: {
        start: 'react-scripts start',
        build: 'react-scripts build',
        test: 'react-scripts test',
        eject: 'react-scripts eject'
      }
    }
  };
  return {
    title: title,
    files: files,
    dependencies: dependencies,
    devDependencies: devDependencies,
    replaceContent: function replaceContent(updater) {
      Object.keys(files).forEach(function (filePath) {
        files[filePath].content = updater(files[filePath].content, filePath);
      });
      return this;
    },
    openSandbox: function openSandbox() {
      var initialFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/App';
      return _openSandbox({
        files: files,
        codeVariant: templateData.codeVariant,
        initialFile: initialFile
      });
    }
  };
}
export default {
  createReactApp: createReactApp,
  createJoyTemplate: createJoyTemplate,
  createMaterialTemplate: createMaterialTemplate
};